import React, { useState } from "react";
import { toast } from "react-toastify";
import { kopecks2rubStr } from "../../../common/functions";
import { IAccount, ITotalByMonth } from "../../../common/accounts2";

import "react-toastify/dist/ReactToastify.css";
import { GetPayments } from "../organoids/GetPayments";
import { GetPaymentsPhis } from "../organoids/GetPaymentPhis";
import { $SiteColors } from "../../../common/config/company-atts";

toast.configure();

interface IBalanceBlock {
  account: IAccount;//аккаунт
  total: ITotalByMonth;
}

//этот компонент отрисовывает баланс текущего аккаунта(Аванс или Задолженность)
export const BalanceBlock = ({ account, total }: IBalanceBlock) => {
  const [showLoader, setShowLoader] = React.useState(false);

  const [showPayments, setShowPayments] = useState(false)
  let balance = kopecks2rubStr(account.balance); //переводим копейки в рубли

  const numbersClassName =
    account.balance >= 0
      ? "payment__text payment__text_green"
      : "payment__text payment__text_red";

  function getPayment() {
    setShowPayments(true)
    // if(account.balance < 0 && account.companyId == AnonComId) {
    //   setShowPayments(true)
    //   return
    // }
    // setShowLoader(true);
    // getPaymentFile(account.account_num)
    //   .then((res) => {
    //     if (res.getPaymentFile) {
    //       if (res.getPaymentFile.message) {
    //         toast.warning(res.getPaymentFile.message);
    //       } else if (res.getPaymentFile.url) {
    //         window.open(res.getPaymentFile.url, "_blank");
    //       } else
    //         throw new Error(
    //           "Не удалось выполнить запрос. Пожалуйста, попробуйте позже"
    //         );
    //     }
    //   })
    //   .catch((err) => {
    //     toast.error(err.message);
    //   })
    //   .finally(() => setShowLoader(false));
  }

  return (
    <div className="payment__container">
      <h4 className="payment__title">
        {account.balance >= 0 ? "Аванс:" : "Задолженность:"}
      </h4>
      <div className="payment__button__wrapper">
        <div className="payment__numbers-button">
          <div className={numbersClassName} style={ account.balance >= 0?{color:$SiteColors.getState().chargeTextColor}:{}}>{balance}</div>
        {/* <button
          type="button"
          className="payment__button"
          style={{ backgroundColor: $SiteColors.getState().backBtnPayDebt }}
          onClick={getPayment}
          disabled={showLoader}
          >
          {showLoader ? <Preloader small={true} /> : "Оплатить"}
        </button> */}
          </div>
      </div>
      {showPayments ? 
      // account.ownerTypeName === "Компания" 
      false
      ?
        <GetPayments comId={account.companyId} setShowPaymentsClicked={setShowPayments} total={total} accountId={account.id} indebtedness={balance} accountNum={account.externalAccountNum} /> :
        <GetPaymentsPhis comId={account.companyId} setShowPaymentsClicked={setShowPayments} total={total} accountId={account.id} indebtedness={balance} accountNum={account.externalAccountNum} />

        : <></>}
    </div>
  );
};
